import React from 'react'

interface CustomToastProps {
  status: string
  className?: string // Optional className prop
  isPrimary?: boolean
}

export const CustomToast: React.FC<CustomToastProps> = ({status, className = '', isPrimary}) => {
  return (
    <div
      className={`${
        isPrimary ? 'alert-primary-dashed alert-primary p-2' : 'alert alert-warning'
      }  ${className}`}
    >
      <div className='text-dark font-weight-bold'>{status}</div>
    </div>
  )
}
